module.exports = __webpack_public_path__ + "img/cybercircuits.6ca7d7be.png";